import styled from "styled-components";
import { CheckMark, ExclamationMark, InfoMark, IconWrapper } from "./AlertIcons";

let Alert = styled.div`
    --alert-bg: transparent;
    --alert-padding-x: 1rem;
    --alert-padding-y: 1rem;
    --alert-margin-bottom: 1rem;
    --alert-color: inherit;
    --alert-border-color: transparent;
    --alert-border: 1px solid var(--alert-border-color);
    --alert-border-radius: 1rem;
    position: relative;
    padding: var(--alert-padding-y) var(--alert-padding-x);
    margin-bottom: var(--alert-margin-bottom);
    color: var(--alert-color);
    background-color: var(--alert-bg);
    border: var(--alert-border);
    border-radius: var(--alert-border-radius,0); 

    //Animation
    transition: opacity .15s linear;

    &>p{
        margin:0;
        font-size: var(--font-S)
    }

    /*
     * Status variants are selected by className — <Alert className={type} /> —
     * which is also how ToastContent and NotificationContent inherit them.
     * surface, not bg: a toast floats over the page, so an alpha fill would
     * let the content behind it show through.
     */
    &.success {
        --alert-color: ${({ theme }) => theme.emotive.success.color};
        --alert-bg: ${({ theme }) => theme.emotive.success.surface};
        --alert-border-color: ${({ theme }) => theme.emotive.success.border};
    }

    &.warning {
        --alert-color: ${({ theme }) => theme.emotive.warning.color};
        --alert-bg: ${({ theme }) => theme.emotive.warning.surface};
        --alert-border-color: ${({ theme }) => theme.emotive.warning.border};
    }

    &.info {
        --alert-color: ${({ theme }) => theme.emotive.info.color};
        --alert-bg: ${({ theme }) => theme.emotive.info.surface};
        --alert-border-color: ${({ theme }) => theme.emotive.info.border};
    }

    &.error {
        --alert-color: ${({ theme }) => theme.emotive.error.color};
        --alert-bg: ${({ theme }) => theme.emotive.error.surface};
        --alert-border-color: ${({ theme }) => theme.emotive.error.border};
    }
`

const AlertHeading = styled.h4`
    font-size: var(--font-M);
    color: inherit;
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    display: grid;
    flex-grow: 1;
`

export const AlertClose = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1rem;
    cursor: pointer;
    box-sizing: content-box;
    width: 1rem;
    height: 1rem;
    color: ${({ theme }) => theme.font.color};
    background-color: transparent;
    background-position: center;
    background-size: 1rem auto;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentColor'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
    border: 0;
    border-radius: 0.375rem;
    opacity: .5;
`

export const AlertIcon = ({ type, size }) => {
    return (
        <IconWrapper $size={size}>
            {
                type === 'success' ?
                    // Checkmark
                    CheckMark :
                    type === 'error' || type === 'warning' ?
                        // Exclamation Mark
                        ExclamationMark :
                        // Info Mark
                        InfoMark
            }
        </IconWrapper>
    )

}


Alert.Heading = AlertHeading
Alert.Close = AlertClose
Alert.Icon = AlertIcon

export default Alert